 // Scripting to handle tabs interaction
(function($){

  //Stop propagation on linked card anchor clicks
  $('.card.linked-card a').click(function(e) {
    e.stopPropagation();
  });

  //Capture card clicks outside of the anchors
  $('.card.linked-card').click(function(e) {
    let $card = $(this).hasClass('card') ? $(this) : $(this).parents('.card');
    let $anchor = $card.find('a').first();

    if ($anchor) {
      window.location = $anchor.attr('href');
    }
  });

})(jQuery);
